import React, { useLayoutEffect } from 'react';

import { Columns } from '~/components/Users/Columns';

import { useAuth } from '~/hooks/useAuth';

import { useAppDispatch } from '~/redux/hooks';

import type { User } from '~/types/models';
import { getColumnFromKey } from '~/types/components';

export default function Profile(): JSX.Element {
  const { user } = useAuth();

  const dispatch = useAppDispatch();

  useLayoutEffect(() => {
    dispatch({ type: 'app/title', payload: 'Profil' });
    dispatch({ type: 'app/icon', payload: 'TbUserCircle' });
    dispatch({ type: 'app/action', payload: undefined });
  });

  const metaColumn = getColumnFromKey<User>(Columns, 'meta');

  return (
    <div className='Profile'>
      {metaColumn?.render && (
        <div>
          <h2>{metaColumn.title}</h2>
          {metaColumn.render(user?.meta)}
        </div>
      )}
    </div>
  );
}
